<template>
  <div class="w-full xl:max-w-209">
    <div class="flex w-full p-3 px-4 mb-8 bg-sw-blue-100">
      <div v-if="variant !== 'none'" class="flex-shrink-0 w-8 xl:w-8 p-0.5 pr-0">
        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.02 0a9 9 0 00-9 9 9 9 0 009 9 9 9 0 000-18zM9 3.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM12 14H6v-1h2V9H7V8h3v5h2v1z" fill="#101010"/></svg>
      </div>
      <div>
        <p class="pb-2 font-bold leading-tight xl:text-lg">
          {{ title }}
        </p>
        <p v-html="message" />
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '~brand-components/base/alert/alert'

export default Alert.extend()
</script>
